import { render, staticRenderFns } from "./ManualImport.vue?vue&type=template&id=5cde65dc&"
import script from "./ManualImport.vue?vue&type=script&lang=js&"
export * from "./ManualImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm,QItemLabel,QSelect,QBtn,QCard,QTable,QSpace,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QItemLabel,QSelect,QBtn,QCard,QTable,QSpace,QTd})
